import styled from "@emotion/styled";
import React from "react";
import zeldmg from "../../../assets/images/100k.png";
import { Text } from "../../Styles/style";
import { HeaderContainer } from "./styles";

const Zeldmg = styled.img`
width: 100%;
max-width: 650px;
height: auto;
`
const Div = styled.div`
display:flex;
gap:20px;
`
const Section1_Header = () => {
  return (
    <HeaderContainer maxWidth="xl">
   <Zeldmg src={zeldmg}/>
      <Text>
      ETH CONTRACT: 0x02570673510011c8bb49d7dafd03ed7d0605648d
      </Text>
      {/* <BuyNow>Buy Now</BuyNow>
      <BuyNow>Live Chart</BuyNow> */}
      {/* <Div>


      <FableButton
        link="https://app.pulsex.com/swap?outputCurrency=0xdeAa385E860b275DE31ba17A8730601b527C26a9"
        btnText="Buy Now"
        Display="none"
      />
      <FableButton
      border="1px solid #fff"
      bgcolor="#000"
        link="https://www.dextools.io/app/en/pulse/pair-explorer/0x6a41316152be2a258417f1b930867be72da556cd"
        btnText="Live Chart"
        Display="none"
      />
        </Div> */}
    </HeaderContainer>
  );
};

export default Section1_Header;
